import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDecimal]'
})
export class DecimalDirective {
  @Input() appDecimal: number[] | string[]| any;

    private specialKeys: Array<string> = ['Backspace','Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  
    constructor(private el: ElementRef) {
    }
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
      let regex: RegExp = (this.appDecimal && this.appDecimal.length == 2) ? new RegExp('^\\d{1,'+this.appDecimal[0]+'}(\\.\\d{0,'+this.appDecimal[1]+'})?$') :  new RegExp(/^\d*(\.\d{0,3})?$/g);
      if (this.specialKeys.indexOf(event.key) !== -1) {
        return;
      }
      let current: string = this.el.nativeElement.value;
      let position = this.el.nativeElement.selectionStart;
      let next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
      // if(event.key=="Backspace"){
      //  let decimalIndex = (next.indexOf("Backspace") -1);
      //   if (next[decimalIndex] == ".") {
      //     next = next.replace('Backspace', '');
      //     next = next.replace('.', '');
      //   }
      //   else {
      //     return
      //   }
      // }
      if (next && !String(next).match(regex)) {
        event.preventDefault();
      }

    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/directive/decimal.directive.ts